import { cn } from '@zep/utils';
export function PriceTextInLabel({
  discountRate,
  originalPrice,
  finalPrice,
  suffix,
  highlighted = false,
  currencyString = '₩',
  className
}: {
  discountRate: number;
  originalPrice: number;
  finalPrice: number;
  suffix: string;
  highlighted?: boolean;
  currencyString: string;
  className?: string;
}) {
  return <div className={cn('flex items-center', className)} data-sentry-component="PriceTextInLabel" data-sentry-source-file="PriceTextInLabel.tsx">
      {discountRate > 0 && <span className={cn('mr-[8px] text-[13px] font-[500] text-gray-500 line-through')}>
          {currencyString}
          {originalPrice.toLocaleString()}
        </span>}
      <span className={cn('text-subtitle font-[700] text-gray-900', highlighted && 'text-primary')}>
        {currencyString}
        {finalPrice.toLocaleString()}
      </span>
      <span className={cn('text-caption-1 ml-[2px] font-[600] text-gray-600', highlighted && 'text-primary')}>
        {suffix}
      </span>
    </div>;
}